import React from 'react';
import classnames from 'classnames';
import { usePagination, DOTS } from './../usePagination/usePagination';
import './Pagination.scss';
const Pagination = props => {
    const {
        onPageChange,
        totalCount,
        siblingCount = 1,
        currentPage,
        pageSize,
        className
    } = props;

    const paginationRange = usePagination({
        currentPage,
        totalCount,
        siblingCount,
        pageSize
    });

    if (currentPage === 0 || paginationRange.length < 2) {
        return null;
    }

    const onNext = () => {
        onPageChange(currentPage + 1);
    };

    const onPrevious = () => {
        onPageChange(currentPage - 1);
    };

    let lastPage = paginationRange[paginationRange.length - 1];
    return (
        <div
            className={classnames('pagination-container', { [className]: className })}>
            <button
                className={classnames('pagination-item pagination-button', {
                    disabled: currentPage === 1
                })}
                onClick={onPrevious}
            >
                <div className="arrow left" />
            </button>
            <ul>
                {paginationRange.map(( pageNumber, index) => {
                    if (pageNumber === DOTS) {
                        return <li className="pagination-item dots" key={index}>&#8230;</li>;
                    }

                    return (
                        <li key={index}>
                            <button type='button' className={classnames('pagination-item', {
                                selected: pageNumber === currentPage
                            })}
                                onClick={() => onPageChange(pageNumber)}>
                                {pageNumber}
                            </button>
                        </li>
                    );
                })}
            </ul>
            <button
                className={classnames('pagination-item pagination-button', {
                    disabled: currentPage === lastPage
                })}
                onClick={onNext}
            >
                <div className="arrow right" />
            </button>
        </div>
    );
};

export default Pagination;